import { render, staticRenderFns } from "./BuddhismRegister.vue?vue&type=template&id=3b79954c&scoped=true"
import script from "./BuddhismRegister.vue?vue&type=script&lang=tsx"
export * from "./BuddhismRegister.vue?vue&type=script&lang=tsx"
import style0 from "./BuddhismRegister.vue?vue&type=style&index=0&id=3b79954c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b79954c",
  null
  
)

export default component.exports